<template>
  <v-container>
    <v-card
      class="mx-auto"
      max-width="600"
      outlined
    >
      <v-card-title>{{ $t('about.title') }}</v-card-title>
      <v-card-subtitle>
        <h4 class="ml-2">Verze: {{ getVersion }}</h4>
      </v-card-subtitle>
      <v-card-text class="px-4">
         {{ $t('about.info')}} <a href="https://www.meeconn.cz">https://www.meeconn.cz</a>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" to="/">{{ $t('app.btn.ok') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'About',
  computed: {
    ...mapGetters(['getVersion'])
  },

}
</script>
